export default __webpack_public_path__ + "static/media/favicon.aa43b9bb.png";